<div class="chip-toggle-wrapper">
  <div
    class="filter-chip"
    role="button"
    tabindex="0"
    [class.filter-chip--selected]="!!control.value"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
  >
    @if (control.value) {
      <span class="filter-chip-text">{{ label }}</span>
      <span
        class="chip-clear-btn"
        role="button"
        tabindex="0"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"
        (keydown.space)="$event.preventDefault(); clear($event)"
      >
        <mat-icon>close</mat-icon>
      </span>
    } @else {
      + {{ label }}
    }
  </div>
</div>
